<template>
  <v-container
    data-vue-component-name="Done"
    class="justify-center"
    fill-height
    fluid
  >
    <v-card
      flat
      max-width="500"
      class="d-flex flex-column align-center"
    >
      <v-card-title>Check complete</v-card-title>

      <v-card-text class="text-center">
        {{ getEndText }}
      </v-card-text>

      <v-btn class="text-capitalize" @click="toNextPage">
        Continue
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { EXERCISES } from '@/constants';
import onSpace from '@/mixins/onSpace';

export default {
  name: 'Done',
  mixins: [onSpace],
  data: () => ({
    onSpaceHandler: 'toNextPage',
  }),
  computed: {
    getEndText() {
      return this.$store.getters.getEndText;
    },
    currentExercise: {
      get() {
        return this.$store.state.currentExercise;
      },
      set(val) {
        this.$store.commit('SET_CURRENT_EXERCISE', val);
      },
    },
    isLastExercise() {
      return this.currentExercise === EXERCISES.length - 1;
    },
  },
  created() {
    if (this.isLastExercise) this.$router.push({ name: 'Upload' });
  },
  methods: {
    toNextPage() {
      if (!this.isLastExercise) {
        this.$store.commit('SET_CURRENT_STEP', 0);
        this.currentExercise++;
        this.$router.push({ name: this.$store.getters.getStepView });
      }
    },
  },
};
</script>
